const buildRelationshipTree = (organizationId, organizations, level = 0) => [
  { organizationId, level },
  ...(organizations[organizationId].children || [])
    .flatMap(childId => buildRelationshipTree(childId, organizations, level + 1))
];

export default buildRelationshipTree;